import Vue from 'vue';
import Vuex from 'vuex';
import global from '../global/index';
import events from './event/event-index';
import forms from './forms/forms-index';
import themes from './themes/themes-index';

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  modules: {
    global,
    events,
    forms,
    themes,
  },
});
